<div class="card-xl-stretch me-md-6 bg-white rounded-4">
  <!--begin::Overlay-->
  <a
    class="d-block overlay"
    data-fslightbox="lightbox-hot-sales"
    [href]="catalogue?.image"
  >
    <!--begin::Image-->
    <div
      class="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-275px"
      [style]="'background-image: url(' + catalogue?.image + ')'"
    ></div>
    <!--end::Image-->
    <!--begin::Action-->
    <div class="overlay-layer card-rounded bg-dark bg-opacity-25">
      <i class="bi bi-eye-fill fs-2x text-white"></i>
    </div>
    <!--end::Action-->
  </a>
  <!--end::Overlay-->
  <!--begin::Body-->
  <div class="mt-5 p-4">
    <!--begin::Title-->
    <div class="d-flex justify-content-between align-items-end border-mt pb-4">
      <a
        [routerLink]="'/catalogue/' + catalogue?.id"
        class="fs-4 text-dark fw-bold text-hover-primary text-dark lh-base"
        >{{ catalogue?.title }}</a
      >

      <span class="p-3 rounded-1 bg-primary text-white text-bold ">
        {{ catalogue?.tiny_code }}
      </span>
    </div>
    <!--end::Title-->
    <!--begin::Text-->
    <div class="fw-semibold fs-5 text-gray-600 text-dark mt-3 text-align-justify">
      {{ catalogue?.description }}
    </div>
    <!--end::Text-->
    <!--begin::Text-->
    <div class="fs-6 fw-bold mt-5 flex-stack">
      

      <div
        class="card-body pt-2 pb-4 d-flex flex-wrap align-items-center justify-content-between"
      >
        <!--begin::Chart-->
        <div class="d-flex flex-center me-5 pt-2">
          <div
            class="chartElement"
            id="kt_card_widget_1_chart"
            [ngStyle]="{
              'min-width': chartSize + 'px',
              'min-height': chartSize + 'px'
            }"
            [attr.data-kt-size]="chartSize"
            [attr.data-kt-line]="chartLine"
          ></div>
        </div>
        <!--end::Chart-->

        <!--begin::Labels-->
        <div class="d-flex flex-column content-justify-center">
          <!--begin::Label-->
          <div
            class="d-flex fw-semibold align-items-center justify-content-between"
          >
            <!--begin::Bullet-->
            <div class="bullet w-8px h-3px rounded-2 bg-success me-3"></div>
            <!--end::Bullet-->

            <!--begin::Label-->
            <div class="text-gray-500 me-4">Score</div>
            <!--end::Label-->

            <!--begin::Stats-->
            <div class="fw-bolder text-gray-700 text-xxl-end">
              {{ catalogue.tracking.score }}%
            </div>
            <!--end::Stats-->
          </div>
          <!--end::Label-->

          <!--begin::Label-->
          <div
            class="d-flex fw-semibold align-items-center justify-content-between my-3"
          >
            <!--begin::Bullet-->
            <div class="bullet w-8px h-3px rounded-2 bg-primary me-3"></div>
            <!--end::Bullet-->

            <!--begin::Label-->
            <div class="text-gray-500 me-4">Progression</div>
            <!--end::Label-->

            <!--begin::Stats-->
            <div class="fw-bolder text-gray-700 text-xxl-end">
              {{ catalogue.tracking.progression }}%
            </div>
            <!--end::Stats-->
          </div>
          <!--end::Label-->

          <!--begin::Label-->
          <div
            class="d-flex fw-semibold align-items-center justify-content-between"
          >
            <!--begin::Bullet-->
            <div
              class="bullet w-8px h-3px rounded-2 me-3"
              style="background-color: #e4e6ef"
            ></div>
            <!--end::Bullet-->

            <!--begin::Label-->
            <div class="text-gray-500 me-4">Temps</div>
            <!--end::Label-->

            <!--begin::Stats-->
            <div class="fw-bolder text-gray-700 text-xxl-end">
              {{ catalogue.tracking.time }}
            </div>
            <!--end::Stats-->
          </div>
          <!--end::Label-->
        </div>
        <!--end::Labels-->
      </div>

      <!--begin::Action-->
      <a
        href="#"
        class="btn btn-primary btn-sm d-flex justify-content-center mb-4 mt-4"
        >S'inscrire</a
      >
      <!--end::Action-->
    </div>
    <!--end::Text-->
  </div>
  <!--end::Body-->
</div>
